import type { Edge } from "@/domains/visualization/types/Edge"
import type { Vertex } from "@/domains/visualization/types/Vertex"

const EXCLUDED_PROPERTIES = ["x", "y", "width", "height", "id", "label", "partitionKey", "name", "parentId"]

/**
 * Checks if a property should be displayed
 * @param key - The property key
 * @param value - The property value
 * @returns True if the property should be displayed, false otherwise
 */
export const shouldDisplayProperty = (key: string, value?: string | null): boolean => {
  return !EXCLUDED_PROPERTIES.includes(key) && !!value
}

/**
 * Finds the parent ID for a node from edges
 * @param nodeId - The ID of the node to find the parent for
 * @param edges - The edges to search through
 * @returns The parent ID or null if no parent is found
 */
export const findParentFromEdges = (nodeId: string, edges: Edge[]): string | null => {
  const parentEdge = edges.find((edge) => edge.inV === nodeId)
  return parentEdge?.outV || null
}

/**
 * Finds a node by its ID from a list of nodes
 * @param nodeId - The ID of the node to find (can be null)
 * @param nodes - The nodes to search through
 * @returns The found node or null if not found
 */
export const findNodeById = (nodeId: string | null, nodes: Vertex[]): Vertex | null => {
  return nodeId ? (nodes.find((node) => node.id === nodeId) ?? null) : null
}
